/* PAWORA — interacciones (prefijo pw-) */
(function () {
  // El script se incluye en varias secciones: ejecutarlo solo una vez
  if (window.__pwScripts) return;
  window.__pwScripts = true;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveals() {
    var els = document.querySelectorAll('.pw-reveal:not(.pw-visible)');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('pw-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('pw-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initParallax() {
    if (reduceMotion) return;
    var items = document.querySelectorAll('[data-pw-parallax]');
    if (!items.length) return;
    var ticking = false;
    function update() {
      items.forEach(function (el) {
        var r = el.getBoundingClientRect();
        var k = parseFloat(el.getAttribute('data-pw-parallax')) || 0;
        var off = (r.top + r.height / 2 - window.innerHeight / 2) * -k / 100;
        el.style.transform = 'translate3d(0,' + off.toFixed(1) + 'px,0) rotate(-2deg)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var conComa = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
    var conPunto = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    return (format || '{{amount_with_comma_separator}} €').replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_with_comma_separator') return conComa;
      if (k === 'amount_no_decimals_with_comma_separator') return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      if (k === 'amount_no_decimals') return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return conPunto;
    });
  }

  function initProducto() {
    document.querySelectorAll('[data-pw-producto]').forEach(function (root) {
      if (root.hasAttribute('data-pw-listo')) return;
      root.setAttribute('data-pw-listo', '');
      // Galería
      var principal = root.querySelector('[data-pw-principal]');
      var minis = root.querySelectorAll('[data-pw-mini]');
      function mostrar(btn) {
        if (!principal || !btn) return;
        principal.style.opacity = '0';
        setTimeout(function () {
          principal.src = btn.getAttribute('data-src');
          principal.srcset = btn.getAttribute('data-srcset') || '';
          principal.alt = btn.getAttribute('data-alt') || '';
          principal.style.opacity = '1';
        }, 180);
        minis.forEach(function (m) { m.classList.toggle('is-activa', m === btn); });
      }
      minis.forEach(function (m) { m.addEventListener('click', function () { mostrar(m); }); });

      // Cantidad
      var qty = root.querySelector('[data-pw-qty]');
      root.querySelectorAll('[data-pw-qty-btn]').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(qty.value, 10) || 1;
          v += parseInt(b.getAttribute('data-pw-qty-btn'), 10);
          qty.value = Math.max(1, v);
        });
      });

      // Barra fija de compra (móvil)
      var barra = root.querySelector('[data-pw-barra]');
      var botonPrincipal = root.querySelector('[data-pw-boton]');
      if (barra && botonPrincipal && 'IntersectionObserver' in window) {
        var barraPrecio = barra.querySelector('[data-pw-barra-precio]');
        var precioEl = root.querySelector('[data-pw-precio]');
        new IntersectionObserver(function (entries) {
          var visible = !entries[0].isIntersecting;
          barra.classList.toggle('is-visible', visible);
          barra.setAttribute('aria-hidden', visible ? 'false' : 'true');
          barra.querySelector('[data-pw-barra-btn]').tabIndex = visible ? 0 : -1;
        }).observe(botonPrincipal);
        barra.querySelector('[data-pw-barra-btn]').addEventListener('click', function () {
          if (botonPrincipal.disabled) { botonPrincipal.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
          botonPrincipal.click();
        });
        if (precioEl && barraPrecio && 'MutationObserver' in window) {
          new MutationObserver(function () { barraPrecio.textContent = precioEl.textContent; })
            .observe(precioEl, { childList: true, characterData: true, subtree: true });
        }
      }

      // Variantes
      var dataEl = root.querySelector('[data-pw-variantes]');
      if (!dataEl) return;
      var variantes = JSON.parse(dataEl.textContent);
      var formato = root.getAttribute('data-pw-money') || '';
      var idInput = root.querySelector('[data-pw-variant-id]');
      var precio = root.querySelector('[data-pw-precio]');
      var antes = root.querySelector('[data-pw-antes]');
      var boton = root.querySelector('[data-pw-boton]');
      var textoBoton = boton ? boton.getAttribute('data-texto') : '';
      var textoAgotado = boton ? boton.getAttribute('data-agotado') : '';
      var etiquetas = root.querySelectorAll('[data-pw-opcion-valor]');

      function actualizar() {
        var elegidas = [];
        root.querySelectorAll('[data-pw-opcion]').forEach(function (fs) {
          var c = fs.querySelector('input:checked');
          elegidas.push(c ? c.value : null);
          var lbl = fs.querySelector('[data-pw-opcion-valor]');
          if (lbl && c) lbl.textContent = c.value;
        });
        var v = variantes.find(function (x) {
          return x.options.every(function (o, i) { return o === elegidas[i]; });
        });
        if (!v) return;
        idInput.value = v.id;
        if (precio) precio.textContent = formatMoney(v.price, formato);
        if (antes) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            antes.textContent = formatMoney(v.compare_at_price, formato);
            antes.hidden = false;
          } else { antes.hidden = true; }
        }
        if (boton) {
          boton.disabled = !v.available;
          boton.querySelector('span').textContent = v.available ? textoBoton : textoAgotado;
        }
        if (v.featured_media_id) {
          var m = root.querySelector('[data-pw-mini][data-media-id="' + v.featured_media_id + '"]');
          if (m) mostrar(m);
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      root.querySelectorAll('[data-pw-opcion] input').forEach(function (inp) {
        inp.addEventListener('change', actualizar);
      });
    });
  }

  function init() { initReveals(); initParallax(); initProducto(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function () { initReveals(); initProducto(); });
})();
